<template>
    <div class="flex-1 d-flex flex-column h-100">
        <div class="flex-1 d-flex flex-column overflow-auto p-4">
           <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-md-4 p-0">
                    <label>{{ $t("res_Label_Structures") }} *</label>
                    <multi-select class="light-bg add-arrow" v-model="structureData.structure" label="name" track-by="id" open-direction="bottom" :options="structures" :searchable="true" :loading="loading" 
                        :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false" @search-change="asyncFindAllDepartments" @close="structures = []" :disabled="structureData.structureDisable" :placeholder="$t('res_Label_Select')">
                        <template slot="option" slot-scope="props">
                            <div style="height: 50px; width: 100%; display: flex">
                                <div class="" style="">
                                    <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                </div>
                                <div class="ad__box" v-if="props.option.isUser">
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                                <div class="ad__box" v-else>
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                            </div>
                        </template>
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </multi-select>
                </div>
                <div class="col-md-4 p-0">
                    <label>{{ $t("res_Label_Role") }} *</label>
                    <multi-select class="light-bg add-arrow" v-model="structureData.contactRole" label="name" track-by="id" open-direction="bottom" :options="contactRoles" :searchable="true" :loading="loading" 
                        :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false" :placeholder="$t('res_Label_Select')">
                    </multi-select>
                </div>
                <div class="col-md-4 flex-1 p-0">
                    <label>{{ $t("res_Label_PrivacyLevel") }} *</label>
                    <multi-select class="light-bg add-arrow" v-model="structureData.privacyLevel" label="name" track-by="id" open-direction="bottom" :options="privacies" :searchable="true" :loading="loading" 
                        :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false" :placeholder="$t('res_Label_Select')">
                    </multi-select>
                </div>
            </div>
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-md-4 p-0">
                    <label>{{$t("res_Label_Profession")}}</label>
                    <v-text-field v-model="structureData.profession" label="" solo></v-text-field>
                </div>
                <div class="col-md-4 p-0">
                    <label>{{$t("res_Label_ProfessionAr")}}</label>
                    <v-text-field v-model="structureData.professionAr" label="" solo></v-text-field>
                </div>
            </div>
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-2 flex-1 p-0">
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isStructureReceiver" :label="$t('res_CheckBox_IsStructureReciever')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isDesignatedPerson" :label="$t('res_Label_IsDesignatedPerson')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isDefaultDesignatedPerson" :label="$t('res_Label_IsDefaultDesignatedPerson')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isCanAddIncoming" :label="$t('res_Label_IsCanAddIncoming')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.canSearchInDepartment" @change="SetSubDep()" :label="$t('res_Label_CanSearchInDep')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.canSearchInSubDepartment" :disabled="!structureData.canSearchInDepartment" :label="$t('res_Label_CanSearchInSubDep')"></v-checkbox>
                </div>
            </div>
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.allowSignSpecial"  :label="$t('res_Label_AllowSignSpecial')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.dontShowInTransfer" :label="$t('res_Label_DontShowInTransfer')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.editSigned"  :label="$t('res_Label_EditSigned')"></v-checkbox>
                </div>
            </div>            
            
            <div class="mt-2">
               <v-btn class="light-blue" style="min-width: 100px !important" @click="resetStructureUser()">{{ $t("res_ButtonText_Reset") }}</v-btn>
                <v-btn class="primary mx-2" style="min-width: 100px !important"  @click="addStructureUser()" v-if="!showUpdateStructureUserBtn">{{ $t("res_ButtonText_Add") }}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important" v-if="showUpdateStructureUserBtn" @click="updateStructureUser()">{{ $t("res_ButtonText_Update") }}</v-btn>
            </div>
            <v-dialog v-model="autoForwardDialog" max-width="50%">
                <div>
                    <v-toolbar class="shadow-none" content-class="h-auto">      
                        <div class="d-flex align-items-center">
                            <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_AutoForwardRules")}}</v-toolbar-title>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="closeAutoForwardDialog()">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                </div>
                <div class="dialog-body bg-white" style="width: 100%; height: 100%;" >
                    <AutoForward :fromStructerId="fromId" :UserId="userId" />
                </div>
            </v-dialog>    
            <hr>
            <v-data-table  class="d-flex flex-column flex-1 order-table" :headers="structureHeaders" 
            :items="structureData.structureDataArray" :items-per-page="10" :class="{'no-data': structureData.structureDataArray.length == 0}" >
                <template v-slot:item="row" item-key="structure">
                    <tr>
                        <td style="display: none">{{ row.item.id }}</td>
                        <td>{{ row.item.structure }}</td>
                        <td>{{ row.item.privacyLevel }}</td>
                        <td>{{ row.item.contactRole }}</td>
                        <td>{{ row.item.profession }}</td>
                        <td>{{ row.item.ProfessionAr }}</td>
                        <td>{{ row.item.isStructureReceiver }}</td>
                        <td>{{ row.item.isDesignatedPerson }}</td>
                        <td>{{ row.item.IsDefaultStructure }}</td>
                        <td>{{ row.item.isCanAddIncoming }}</td>
                        <td>{{ row.item.canSearchInDepartment }}</td>
                        <td>{{ row.item.canSearchInSubDepartment }}</td>
                        <td>{{ row.item.allowSignSpecial }}</td>
                        <td>{{ row.item.dontShowInTransfer }}</td>
                        <td>{{ row.item.editSigned }}</td>

                        <td class="text-start">
                            <div class="onhover-display">
                                <div class="custom-icon-wrapper" v-if="!row.item.IsDefaultStructure" >
                                    <v-icon @click="makeDefaultStructure(row.item.id)">custom-icon primary-bg plus1-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper">
                                    <v-icon @click="showEditStructureUserData(row.item)" >custom-icon white-bg edit-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="!row.item.IsDefaultStructure">
                                    <v-icon @click="deleteStructure(row.item.id)" >custom-icon white-bg delete-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="hasPermission('AutoForward')" >
                                    <v-icon title="Forward" @click="openAutoForwardDialog(row.item.id)" >mdi-forward</v-icon>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                <v-row class="p-5">
                    <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                    <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                </v-row>
            </template>
            </v-data-table>
            </div>
        <v-card-actions class="gap-2 sticky-actions">
            <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="close()">{{$t("res_ButtonText_Cancel")}}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'
    import MultiSelect from 'vue-multiselect'
	import * as utils from '@/assets/js/common.js'
    import AutoForward from './AutoForward.vue';
    
    export default {
        name: 'ManageStructures',
        components: { MultiSelect, AutoForward},
        data: function () 
        {
            return {
                showUpdateStructureUserBtn: false,
                managerUserStructureDialog: false,
                loading: false,
                autoForwardDialog:false,
                structures: [],
                constants:constants,
                fromId:null,
                privacies: [],
                contactRoles: [],
                structureData: {
                    structure: null,
                    contactRole: null,
                    privacyLevel: null,
                    profession: '',
                    professionAr: '',
                    isStructureReceiver: false,
                    isDesignatedPerson: false,
                    isDefaultDesignatedPerson: false,
                    isCanAddIncoming:false,
                    editSigned:false,
                    structureDataArray: [],
                    structureDisable: false,
                    canSearchInDepartment: false,
                    canSearchInSubDepartment: false,
                    allowSignSpecial: false,
                    dontShowInTransfer: false
                },
                structureHeaders: [
                    { text: 'Id', value: 'id', sortable: false, align: ' d-none'},
                    { text: this.$t("res_GridHeaders_StructureName"), value: 'structure', sortable: false },
                    { text: this.$t("res_GridHeaders_PrivacyLevel"), value: 'privacyLevel', sortable: false },
                    { text: this.$t("res_GridHeaders_ContactRole"), value: 'contactRole', sortable: false },
                    { text: this.$t("res_GridHeaders_Profession"), value: 'profession', sortable: false },
                    { text: this.$t("res_GridHeaders_ProfessionAr"), value: 'ProfessionAr', sortable: false },
                    { text: this.$t("res_GridHeaders_StructureReceiver"), value: 'isStructureReceiver', sortable: false },
                    { text: this.$t("res_GridHeaders_DesignatedPerson"), value: 'isDesignatedPerson', sortable: false },
                    { text: this.$t("res_GridHeaders_IsDefaultStructure"), value: 'IsDefaultStructure', sortable: false},
                    { text: this.$t("res_GridHeaders_Iscanaddincoming"), value: 'isCanAddIncoming', sortable: false},
                    { text: this.$t("res_Label_CanSearchInDep"), value: 'canSearchInDepartment', sortable: false},
                    { text: this.$t("res_Label_CanSearchInSubDep"), value: 'canSearchInSubDepartment', sortable: false},
                    { text: this.$t("res_Label_AllowSignSpecial"), value: 'allowSignSpecial', sortable: false},
                    { text: this.$t("res_Label_DontShowInTransfer"), value: 'dontShowInTransfer', sortable: false},
                    { text: this.$t("res_Label_EditSigned"), value: 'editSigned', sortable: false},
                    { text: '', value: '', sortable: false, width: '130px'},
                ],
            };
        },
        props: {
            userId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
        },
        methods: 
        {
            initForm()
            {
                this.contactRoles = constants.contactRoles
                this.privacies = constants.privacies
                this.fetchNewStructure();
            },
            asyncFindAllDepartments(query) 
            {
                this.structures = [];
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=false&search=';

                this.loading = true
                window.showLoading();
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => 
                    {
                        if (res.data != null)
                        {
                            this.structures = res.data
                            this.loading = false
                        }
                    })
                    .catch(() => this.loading = false)
                    .finally(()=> window.hideLoading())
            },
            fetchNewStructure()
            {
                this.structureData.structureDataArray = [];
                window.showLoading();
                axios.post(constants.baseApiUrl + 'StructureUser/GetUserStructures?userID=' + this.userId, { headers: constants.headers })
                    .then(response => 
                    {
                        console.log('result  = ',response)
                        if (response.data != null)
                        {
                            response.data.forEach((element) =>
                            {
                                let privacyLevel = "";
                                let contactRole = "";
                                
                                if (element.privacyLevel)
                                    privacyLevel = this.privacies.find(x => x.id == element.privacyLevel).name;

                                if (element.contactRoleId)
                                    contactRole = this.contactRoles.find(x => x.id == element.contactRoleId).name;
console.log('element = ',element)
                                var structureDataBody = {
                                    id: element.structureId,
                                    structure: element.structureName,
                                    privacyLevel: privacyLevel,
                                    contactRole: contactRole,
                                    profession: element.profession,
                                    ProfessionAr: element.professionAr,
                                    isStructureReceiver: element.isStructureReceiver != null ? element.isStructureReceiver : false,
                                    isDesignatedPerson: element.isDesignatedPerson != null ? element.isDesignatedPerson : false,
                                    isDefaultDesignatedPerson: element.isDefaultDesignatedPerson != null ? element.isDefaultDesignatedPerson : false,
                                    IsDefaultStructure: element.isDefaultStructure,
                                    isCanAddIncoming: element.isCanAddIncoming != null ? element.isCanAddIncoming : false,
                                    allowSignSpecial: element.allowSignSpecial != null ? element.allowSignSpecial : false,
                                    dontShowInTransfer: element.dontShowInTransfer != null ? element.dontShowInTransfer : false,
                                    editSigned: element.editSigned != null ? element.editSigned : false,
                                    canSearchInDepartment: element.canSearchInDepartment,
                                    canSearchInSubDepartment: element.canSearchInSubDepartment
                                }

                                this.structureData.structureDataArray.push(structureDataBody);
                            });

                            this.managerUserStructureDialog = true;
                        }
                    }).catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            showEditStructureUserData(item)
            {
                this.showUpdateStructureUserBtn = true;
                this.structureData.structure = {name: item.structure, id: item.id};
                this.structureData.structureDisable = true;
                this.structureData.contactRole = this.contactRoles.find(x => x.name == item.contactRole);
                this.structureData.privacyLevel =  this.privacies.find(x => x.name == item.privacyLevel);
                this.structureData.profession = item.profession;
                this.structureData.professionAr = item.ProfessionAr;
                this.structureData.isStructureReceiver = item.isStructureReceiver;
                this.structureData.isDesignatedPerson = item.isDesignatedPerson;
                this.structureData.isDefaultDesignatedPerson = item.isDefaultDesignatedPerson;
                this.structureData.isCanAddIncoming = item.isCanAddIncoming;
                this.structureData.allowSignSpecial = item.allowSignSpecial;
                this.structureData.dontShowInTransfer = item.dontShowInTransfer;
                this.structureData.editSigned = item.editSigned;
                this.structureData.canSearchInDepartment = item.canSearchInDepartment;
                this.structureData.canSearchInSubDepartment = item.canSearchInSubDepartment;
            },
            makeDefaultStructure(structureId)
            {
                window.showLoading();
                axios.post(constants.baseApiUrl + 'User/UpdateDefaultUser?userId=' + this.userId + "&structureId=" + structureId, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            window.showAlert(this.$t("res_Msgs_SetDefaultStructure"), 'success');
                            this.resetStructureUser();
                            this.fetchNewStructure();
                        }
                    }) 
                    .catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            openAutoForwardDialog(id){
                this.fromId=id;
                this.autoForwardDialog=true;
             },
             closeAutoForwardDialog(){
                this.autoForwardDialog=false;
             },
            deleteStructure(structureId)
            {
                window.showInformation(	
                    this.$t("res_Msgs_Confirmation"),	
                    this.$t("res_Msgs_DeletConfirmation"),	
                    () =>	
                    {	
                        window.showLoading();
                        axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureUser?UserId=' + this.userId + '&StructureId=' 
                            + structureId, { headers: constants.headers })
                            .then(response => 
                            {
                                if (response.data != null && response.data != "success")
                                {
                                    window.showAlert(response.data, 'warning');
                                }
                                else
                                {
                                    this.fetchNewStructure();
                                }
                            })
                        .catch(err => console.warn(err))
                        .finally(()=> window.hideLoading())
                },	
                () => { });	
            },
            SetSubDep()
            {
                if (this.structureData.canSearchInDepartment == false)
                    this.structureData.canSearchInSubDepartment = false
            },
            resetStructureUser()
            {
                this.structureData.structure = null
                this.structureData.contactRole =  null
                this.structureData.privacyLevel =  null
                this.structureData.profession = ''
                this.structureData.professionAr = ''
                this.structureData.isStructureReceiver = false
                this.structureData.isDesignatedPerson = false
                this.structureData.isDefaultDesignatedPerson = false
                this.showUpdateStructureUserBtn = false
                this.structureData.structureDisable = false
                this.structureData.isCanAddIncoming = true
                this.structureData.allowSignSpecial = false
                this.structureData.dontShowInTransfer = false
                this.structureData.editSigned = false
                this.canSearchInDepartment = false
                this.canSearchInSubDepartment = false
            },
            addStructureUser()
            {
                if (this.structureData.structure == null || this.structureData.privacyLevel == null || this.structureData.contactRole == null)
                {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                    return
                }

                var addStructureDataBody = {
                    UserId:  this.userId,
                    StructureId: this.structureData.structure.id,
                    Profession: this.structureData.profession,
                    ProfessionAr: this.structureData.professionAr,
                    IsStructureReceiver: this.structureData.isStructureReceiver != null ? this.structureData.isStructureReceiver : false,
                    IsDesignatedPerson: this.structureData.isDesignatedPerson != null ? this.structureData.isDesignatedPerson : false,
                    IsDefaultDesignatedPerson: this.structureData.isDefaultDesignatedPerson != null ? this.structureData.isDefaultDesignatedPerson : false,
                    PrivacyLevel: this.structureData.privacyLevel.id,
                    ContactRoleId: this.structureData.contactRole.id,
                    isCanAddIncoming: this.structureData.isCanAddIncoming != null ? this.structureData.isCanAddIncoming :false,
                    allowSignSpecial: this.structureData.allowSignSpecial != null ? this.structureData.allowSignSpecial :false,
                    dontShowInTransfer: this.structureData.dontShowInTransfer != null ? this.structureData.dontShowInTransfer :false,
                    editSigned: this.structureData.editSigned != null ? this.structureData.editSigned :false,
                    canSearchInDepartment: this.structureData.canSearchInDepartment,
                    canSearchInSubDepartment: this.structureData.canSearchInSubDepartment
                }

                window.showLoading();
                axios.post(constants.baseApiUrl + 'StructureUser/AddStructureUser',  addStructureDataBody, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            if(response.data == 1)
                                window.showAlert(this.$t("res_Msgs_UserStructureUpdated"), 'success');
                            else if(response.data == 2)
                                window.showAlert(this.$t("res_Msgs_UserStructureAdded"), 'success');

                            this.resetStructureUser();
                            this.fetchNewStructure();
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            updateStructureUser()
            {
                if (this.structureData.structure == null || this.structureData.privacyLevel == null || this.structureData.contactRole == null)
                {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                    return
                }

                var updateStructureDataBody = {
                    UserId:  this.userId,
                    StructureId: this.structureData.structure.id,
                    Profession: this.structureData.profession,
                    ProfessionAr: this.structureData.professionAr,
                    IsStructureReceiver: this.structureData.isStructureReceiver != null ? this.structureData.isStructureReceiver : false,
                    IsDesignatedPerson: this.structureData.isDesignatedPerson != null ? this.structureData.isDesignatedPerson : false,
                    IsDefaultDesignatedPerson: this.structureData.isDefaultDesignatedPerson != null ? this.structureData.isDefaultDesignatedPerson : false,
                    PrivacyLevel: this.structureData.privacyLevel.id,
                    ContactRoleId: this.structureData.contactRole.id,
                    isCanAddIncoming: this.structureData.isCanAddIncoming != null ? this.structureData.isCanAddIncoming : false,
                    allowSignSpecial: this.structureData.allowSignSpecial != null ? this.structureData.allowSignSpecial : false,
                    dontShowInTransfer: this.structureData.dontShowInTransfer != null ? this.structureData.dontShowInTransfer : false,
                    editSigned: this.structureData.editSigned != null ? this.structureData.editSigned : false,
                    canSearchInDepartment: this.structureData.canSearchInDepartment,
                    canSearchInSubDepartment: this.structureData.canSearchInSubDepartment
                }

                window.showLoading();
                axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureUser',  updateStructureDataBody, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response != null && response != undefined)
                        {
                            if (response.data =='success')
                            {
                                window.showAlert("res_Msgs_UpdateStructureSuccess", 'success');
                                this.showUpdateStructureUserBtn = false;
                                this.resetStructureUser();
                                this.fetchNewStructure()
                            }
                            else
                            {
                                window.showAlert(response.data, 'warning');
                            }
                        }
                    })
                    .catch(err => console.warn(err))     
                    .finally(()=> window.hideLoading())
            },
            deleteStructureUser(item)
            {          
                window.showLoading();
                axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureUser?UserId=' + this.userId + '&StructureId=' 
                    +  item.id, { headers: constants.headers })
                    .then(response => 
                    {
                        if(response.data != null)
                        {
                            window.showAlert(this.$t("res_Msgs_DeleteStructureSuccess"), 'success');
                            this.resetStructureUser();
                            this.fetchNewStructure();
                        }
                    })
                    .catch(err => console.warn(err))     
                    .finally(()=> window.hideLoading())
            },
            close()
            {
                this.$emit('closeDialog')
            },
            CapitalizeFirstLetter(str)
            {
				return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            hasPermission(featureName) {
                if (constants.userActions && constants.userActions.features) {
                    console.log(constants.userActions.features);
                    return constants.userActions.features.some(f => f.name.toLowerCase() == featureName.toLowerCase());
                }
                return false;
            }
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.initForm()
                    else
                        this.resetStructureUser()
                }
            }
        },
        mounted() {
            this.initForm();
        }
    }
</script>